export const showColumns = [
    {
        title: 'objectId',
        show: true,
    },
    {
        title: 'objectName',
        show: true,
    },
    {
        title: 'groupId',
        show: true,
    },
    {
        title: 'normalizedTime',
        show: true,
    },
    {
        title: 'OAT',
        show: true,
    },
    {
        title: 'dewpt',
        show: true,
    },
    {
        title: 'enthalpy',
        show: true,
    },
    {
        title: 'pointCode',
        show: true,
    },
    {
        title: 'pointId',
        show: true,
    },
    {
        title: 'componentPointId',
        show: true,
    },
    {
        title: 'timestamp',
        show: true,
    },
    {
        title: 'value',
        show: true,
    },
    {
        title: 'stale',
        show: true,
    },
    {
        title: 'down',
        show: true,
    },
    {
        title: 'fault',
        show: true,
    },
    {
        title: 'duplicate',
        show: true,
    },
    {
        title: 'error',
        show: true,
    },
    {
        title: 'functionId',
        show: true,
    },
    {
        title: 'F_name',
        show: true,
    },
    {
        title: 'F_value',
        show: true,
    },
    {
        title: 'F_error',
        show: true,
    }
];